import { useTranslate } from '@tolgee/react';
import Empty from 'components/Empty';
import { Button } from 'antd';
import { isArray, isEmpty } from 'lodash-es';

interface ConversationListEmptyProps {
  onRefresh: () => void;
  onClearFilterAndRefresh: () => void;
  queryConversationListParams: ApiConversation.ConversationListAdvanceParams;
}

export const ConversationListEmpty = (props: ConversationListEmptyProps) => {
  const { onRefresh, onClearFilterAndRefresh, queryConversationListParams } = props;
  const { t } = useTranslate();

  const hasFilter = Object.values(queryConversationListParams).some((v) => {
    if (isArray(v)) {
      return v.length > 0;
    }
    return !isEmpty(v);
  });

  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-2">
      <div className="flex items-center gap-2">
        <Empty
          imageWidth={80}
          imageHeight={80}
          description={
            <div className="flex flex-col items-center">
              {hasFilter ? (
                <>
                  <span>{t('scene.chatWorkspace.conversationList.empty.noMatchedData')}</span>
                  <Button type="link" onClick={onClearFilterAndRefresh}>
                    {t('common.action.clearFilter')}
                  </Button>
                </>
              ) : (
                <>
                  {t('scene.chatWorkspace.conversationList.empty.storeSelector')}
                  <Button type="link" onClick={onRefresh}>
                    {t('common.action.refresh')}
                  </Button>
                </>
              )}
            </div>
          }
        />
      </div>
    </div>
  );
};
